import { Link } from 'react-router-dom';
import { LegalPageShell, legalStyles as s } from '../components/LegalPageShell';

export function PrivacyPage() {
  return (
    <LegalPageShell title="Privacy Policy">
      <section>
        <p>
          BidMaster values your privacy and is committed to protecting your personal and business information.
        </p>
      </section>

      <section>
        <h2 className={s.h2}>1. Information We Collect</h2>
        <p className="mb-3">We may collect:</p>
        <ul className={s.ul}>
          <li>Name</li>
          <li>Company details</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Billing information</li>
          <li>Auction participation data</li>
          <li>Device and browser information</li>
        </ul>
      </section>

      <section>
        <h2 className={s.h2}>2. How We Use Information</h2>
        <p className="mb-3">Collected information is used for:</p>
        <ul className={s.ul}>
          <li>Account creation and authentication</li>
          <li>Subscription management</li>
          <li>Payment processing</li>
          <li>Auction participation management</li>
          <li>Platform improvement and analytics</li>
          <li>Customer support and communication</li>
        </ul>
      </section>

      <section>
        <h2 className={s.h2}>3. Payment Information</h2>
        <p>
          Payments are securely processed through Razorpay and associated banking/payment partners. BidMaster does not
          store complete card or banking information on its own servers.
        </p>
      </section>

      <section>
        <h2 className={s.h2}>4. Data Protection</h2>
        <p className="mb-3">We implement reasonable security practices including:</p>
        <ul className={s.ul}>
          <li>Secure authentication</li>
          <li>Encrypted communication</li>
          <li>Controlled access systems</li>
          <li>Enterprise-grade platform security measures</li>
        </ul>
      </section>

      <section>
        <h2 className={s.h2}>5. Data Sharing</h2>
        <p className="mb-3">BidMaster does not sell user data. Information may only be shared:</p>
        <ul className={s.ul}>
          <li>With payment partners for transaction processing</li>
          <li>When legally required by authorities</li>
          <li>For fraud prevention and security purposes</li>
        </ul>
      </section>

      <section>
        <h2 className={s.h2}>6. Cookies</h2>
        <p>
          Our website may use cookies and analytics tools to improve user experience and platform performance.
        </p>
      </section>

      <section>
        <h2 className={s.h2}>7. User Rights</h2>
        <p className="mb-3">Users may request:</p>
        <ul className={s.ul}>
          <li>Access to their information</li>
          <li>Correction of inaccurate information</li>
          <li>Account deletion subject to applicable legal obligations</li>
        </ul>
      </section>

      <section>
        <h2 className={s.h2}>8. Policy Updates</h2>
        <p>
          BidMaster reserves the right to update this Privacy Policy at any time. For questions, visit our{' '}
          <Link to="/contact" className={s.link}>
            Contact Us
          </Link>{' '}
          page.
        </p>
      </section>
    </LegalPageShell>
  );
}
